<script lang="ts">
	import { getRentalTemplateContext } from "./rental-template-context.svelte";
	import { cloudinaryVideoPoster, cloudinaryVideoUrl } from "#lib/shared/cloudinary.js";

	const templateContext = getRentalTemplateContext()!;

	const publicId = $derived(templateContext.heroVideoPublicId ?? "");
	const videoPoster = $derived(
		publicId ? cloudinaryVideoPoster(publicId, { width: 1280 }) : undefined
	);
	const videoDesktop = $derived(
		publicId ? cloudinaryVideoUrl(publicId, { width: 1280, quality: "auto" }) : undefined
	);
	const videoMobile = $derived(
		publicId ? cloudinaryVideoUrl(publicId, { width: 480, quality: "auto" }) : undefined
	);

	const availabilityHref = $derived(
		templateContext.buildiumPropertyIds.length === 0 && templateContext.availabilityUrl
			? templateContext.availabilityUrl
			: "#availability"
	);
	const availabilityExternal = $derived(availabilityHref.startsWith("http"));
	const showAvailability = $derived(
		templateContext.buildiumPropertyIds.length > 0 || !!templateContext.availabilityUrl
	);
</script>

<section class="relative h-[70vh] w-full overflow-hidden">
	<!-- Background media container -->
	<div class="absolute inset-0 z-0">
		<img
			src={templateContext.heroImage}
			alt="Property background"
			fetchpriority="high"
			class="absolute inset-0 h-full w-full object-cover"
			aria-hidden="true"
			width="1920"
			height="1080"
			loading="eager"
		/>

		{#if videoDesktop}
			<video
				poster={videoPoster}
				autoplay
				loop
				muted
				playsinline
				preload="metadata"
				class="absolute inset-0 h-full w-full object-cover"
				aria-hidden="true"
			>
				<source src={videoDesktop} media="(min-width: 768px)" type="video/mp4" />
				<source src={videoMobile} type="video/mp4" />
			</video>
		{/if}

		<!-- Overlay -->
		<div class="absolute inset-0 bg-black/50" aria-hidden="true"></div>
	</div>

	<!-- Content container with better centering -->
	<div class="absolute inset-0 z-10 flex items-center justify-center">
		<div class="flex flex-col items-center justify-center px-4 text-center text-white">
			<h1 class="mb-4 text-4xl font-bold tracking-wide md:text-6xl">
				{templateContext.name.toUpperCase()}
			</h1>
			<p class="mb-8 text-xl md:text-2xl">{templateContext.tagline}</p>

			<div class="flex flex-col gap-4 sm:flex-row">
				{#if showAvailability}
					<a
						href={availabilityHref}
						target={availabilityExternal ? "_blank" : undefined}
						rel={availabilityExternal ? "noopener noreferrer" : undefined}
						class="bg-primary text-primary-foreground hover:bg-primary/80 rounded px-6 py-3 transition-colors duration-200"
					>
						<span class="text-lg font-bold drop-shadow-sm">AVAILABILITY</span>
					</a>
				{/if}
				<a
					href={templateContext.overrides?.residentPortalUrl ??
						templateContext.tenantPortal}
					target="_blank"
					rel="noopener noreferrer external"
					class="bg-primary text-primary-foreground hover:bg-primary/80 rounded px-6 py-3 transition-colors duration-200"
				>
					<span class="text-lg font-bold drop-shadow-sm">TENANT PORTAL</span>
				</a>
			</div>
		</div>
	</div>
</section>
